import { Link, type LinkProps } from 'react-router-dom'

import { localizePath } from '@/navigation/locale'
import { useLandingLocale } from '@/navigation/useLandingLocale'

type LocaleLinkProps = Omit<LinkProps, 'to'> & {
    to: string
}

/** React Router `Link` that localizes `to` for the current locale (EN prefix + translated segments/slugs). */
export function LocaleLink({ to, ...props }: LocaleLinkProps) {
    const locale = useLandingLocale()
    const [pathname, hash] = to.split('#')
    const localized = localizePath(pathname || '/', locale)
    const target = hash !== undefined && to.includes('#') ? `${localized}#${hash}` : localized
    return <Link to={target} {...props} />
}
